import { css } from '@emotion/css';

import { LARGE_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const logoClassName = css({
  height: 100,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  flexShrink: 0,
  marginBottom: Spacing.MD,
  [LARGE_DEVICE_MQ]: {
    height: 172,
    marginBottom: 0,
  }
});

export const iconClassName = css({
  width: 44,
});
